import React from "react";

export const PoweredBy: React.FC = () => {

    return <div
        className="flex flex-row gap-2 text-[12px] items-center text-gray-900"
    >
        Powered by
        <img className="h-[20px] mt-[2px]" src="/motor-tech-logo.png" alt="MotorTech.ai"/>
        <span className="font-bold">
            MotorTech.ai
        </span>
    </div>
}
